(function DestinationCity($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Destinations/city', function onload() {
			var $page = $('section.page');

			Adzuki.Ajax.get(
				'/Weather/forecast/'+$page.data('city-id')+'/'+moment().format('YYYY-MM-DD')
			)
			.then(function weather(data) {
				$('.weather-forecast').html(data);
			});
		});
	});
}(jQuery, window.Adzuki || {}));
